module.exports = __webpack_public_path__ + "static/media/main idea.7574e91d.mp3";